// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import { useMediaQuery as useMediaQueryMui } from "@mui/material";

/**
 * Our hook works just as MaterialUI's, but disables SSR by default since we are client-only
 * This prevents double-rendering, which is necessary for server-side hydration
 *
 * @see https://next.material-ui.com/components/use-media-query/#api
 */
function useMediaQuery(query, options = { noSsr: true }) {
  return useMediaQueryMui(query, options);
}

export default useMediaQuery;
